import { USER_TYPE } from '@/enums/userType';

import { ROUTE } from './route';

interface MenuItemProps {
  title: string;
  icon: string;
  path: string;
  roles: string[];
  groupStart?: boolean;
  action?: () => void;
  tracking: {
    event_id: string;
    event_categorie: string;
    event_metier: string;
    event_nom: string;
    event_detail_1: string;
    event_detail_2?: string;
  };
}

const MenuItems: MenuItemProps[] = [
  {
    title: 'navigation.home',
    icon: 'home',
    path: ROUTE.DASHBOARD,
    roles: Object.values(USER_TYPE),
    groupStart: true,
    tracking: {
      event_id: 'clic',
      event_categorie: 'clic',
      event_metier: 'espace client placement',
      event_nom: 'accueil_espace_client',
      event_detail_1: 'menu_lateral',
    },
  },
  {
    title: 'navigation.contracts',
    icon: 'folder',
    path: ROUTE.CONTRATS,
    roles: [USER_TYPE.client],
    tracking: {
      event_id: 'clic',
      event_categorie: 'clic',
      event_metier: 'espace client placement',
      event_nom: 'mes_contrats',
      event_detail_1: 'menu_lateral',
    },
  },
  {
    title: 'navigation.operations',
    icon: 'transaction',
    path: ROUTE.OPERATIONS,
    roles: [USER_TYPE.client],
    tracking: {
      event_id: 'clic',
      event_categorie: 'clic',
      event_metier: 'espace client placement',
      event_nom: 'mes_operations',
      event_detail_1: 'menu_lateral',
    },
  },

  {
    title: 'navigation.invest',
    icon: 'growth-arrow',
    path: ROUTE.INVESTIR,
    roles: Object.values(USER_TYPE),
    groupStart: true,
    tracking: {
      event_id: 'clic',
      event_categorie: 'clic',
      event_metier: 'espace client placement',
      event_nom: 'investir',
      event_detail_1: 'menu_lateral',
    },
  },

  {
    title: 'navigation.sponsorship',
    icon: 'users',
    path: ROUTE.PARRAINAGE,
    roles: Object.values(USER_TYPE),
    tracking: {
      event_id: 'clic',
      event_categorie: 'clic',
      event_metier: 'espace client placement',
      event_nom: 'parrainage',
      event_detail_1: 'menu_lateral',
    },
  },

  {
    title: 'navigation.otherAccess',
    icon: 'key',
    path: ROUTE.AUTRESACCES,
    roles: [USER_TYPE.client],
    groupStart: true,
    tracking: {
      event_id: 'clic',
      event_categorie: 'clic',
      event_metier: 'espace client placement',
      event_nom: 'mes_autres_acces',
      event_detail_1: 'menu_lateral',
    },
  },
];

const UserMenuItems: MenuItemProps[] = [
  {
    title: 'navigation.help',
    icon: 'chat',
    path: ROUTE.HELP,
    roles: Object.values(USER_TYPE),
    tracking: {
      event_id: 'clic',
      event_categorie: 'clic',
      event_metier: 'espace client placement',
      event_nom: 'besoin_d_aide',
      event_detail_1: 'menu_lateral',
      event_detail_2: 'menu_lateral_secondaire',
    },
  },
  {
    title: 'navigation.informations',
    icon: 'user',
    path: ROUTE.INFORMATIONS,
    roles: Object.values(USER_TYPE),
    tracking: {
      event_id: 'clic',
      event_categorie: 'clic',
      event_metier: 'espace client placement',
      event_nom: 'mes_informations',
      event_detail_1: 'menu_lateral',
      event_detail_2: 'menu_lateral_secondaire',
    },
  },
  {
    title: 'navigation.logout',
    icon: 'logout',
    path: ROUTE.LOGIN,
    roles: Object.values(USER_TYPE),
    tracking: {
      event_id: 'clic',
      event_categorie: 'clic',
      event_metier: 'espace client placement',
      event_nom: 'deconnexion',
      event_detail_1: 'menu_lateral',
      event_detail_2: 'menu_lateral_secondaire',
    },
  },
];

export { MenuItems, UserMenuItems };
export type { MenuItemProps };
